// UPost.com - Logo Showcase Component (for testing different variants)
import React, { useState } from 'react';
import { Logo, LogoMultiAuthor } from './Logo';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { Button } from './ui/button';

export function LogoShowcase() {
  const [variant, setVariant] = useState('full');
  const [size, setSize] = useState('md');

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl font-bold mb-8 text-center">UPost.com Logo Variants</h1>
        
        {/* Controls */}
        <div className="flex justify-center gap-4 mb-8">
          <div className="space-x-2">
            <span className="text-sm font-semibold">Variant:</span>
            <Button size="sm" variant={variant === 'full' ? 'default' : 'outline'} onClick={() => setVariant('full')}>Full</Button>
            <Button size="sm" variant={variant === 'minimal' ? 'default' : 'outline'} onClick={() => setVariant('minimal')}>Minimal</Button>
            <Button size="sm" variant={variant === 'icon' ? 'default' : 'outline'} onClick={() => setVariant('icon')}>Icon</Button>
          </div>
          <div className="space-x-2">
            <span className="text-sm font-semibold">Size:</span>
            <Button size="sm" variant={size === 'sm' ? 'default' : 'outline'} onClick={() => setSize('sm')}>SM</Button>
            <Button size="sm" variant={size === 'md' ? 'default' : 'outline'} onClick={() => setSize('md')}>MD</Button>
            <Button size="sm" variant={size === 'lg' ? 'default' : 'outline'} onClick={() => setSize('lg')}>LG</Button>
            <Button size="sm" variant={size === 'xl' ? 'default' : 'outline'} onClick={() => setSize('xl')}>XL</Button>
          </div>
        </div>

        {/* Preview */}
        <Card className="mb-8">
          <CardHeader>
            <CardTitle>Current Selection</CardTitle>
          </CardHeader>
          <CardContent className="flex items-center justify-center py-12 bg-white">
            <Logo variant={variant} size={size} />
          </CardContent>
        </Card>

        {/* All Variants */}
        <div className="grid md:grid-cols-2 gap-6">
          <Card>
            <CardHeader>
              <CardTitle>Full Logo (with Mark Twain)</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <Logo variant="full" size="sm" />
              </div>
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <Logo variant="full" size="md" />
              </div>
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <Logo variant="full" size="lg" />
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Minimal Logo</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <Logo variant="minimal" size="sm" />
              </div>
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <Logo variant="minimal" size="md" />
              </div>
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <Logo variant="minimal" size="lg" />
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Icon Only</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <Logo variant="icon" size="sm" />
              </div>
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <Logo variant="icon" size="md" />
              </div>
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <Logo variant="icon" size="lg" />
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Multi-Author Logo</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <LogoMultiAuthor size="sm" />
              </div>
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <LogoMultiAuthor size="md" />
              </div>
              <div className="bg-white p-6 rounded border flex items-center justify-center">
                <LogoMultiAuthor size="lg" />
              </div>
            </CardContent>
          </Card>
        </div>

        {/* On Dark Background */}
        <Card className="mt-6">
          <CardHeader>
            <CardTitle>On Dark Background</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-gray-900 p-8 rounded space-y-4">
              <div className="flex items-center justify-center">
                <Logo variant="full" size="md" />
              </div>
              <div className="flex items-center justify-center">
                <LogoMultiAuthor size="md" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}